import { CosmosDb } from 'lib/cosmos/cosmosDb.js';

export class LinkedItemsHelper {
	getLinkedItemById<TItem extends CosmosDb.ICosmosItem>(
		linkedItems: readonly CosmosDb.ICosmosItem[],
		id: string
	): TItem | undefined {
		return linkedItems.find((m) => m.id === id) as TItem;
	}

	getLinkedItemsByType<TItem extends CosmosDb.ICosmosItem>(
		linkedItems: readonly CosmosDb.ICosmosItem[],
		type: CosmosDb.CosmosContainerType
	): readonly TItem[] {
		return (
			linkedItems.filter((m) => m.system.type?.toLowerCase() === type.toLowerCase()).map((m) => m as TItem) ?? []
		);
	}
}

export const linkedItemsHelper = new LinkedItemsHelper();
